import Loadable from '@loadable/component'

export const MultipleLeasingFormModal = Loadable(
  /* webpackChunkName: "MultipleLeasingFormModal" */
  /* webpackPrefetch: "true" */
  /* #__LOADABLE__ */
  () => import('./MultipleLeasingForm'),
)
